// ============================================================================
// FSA CORPORATE FACTS ENDPOINTS (ADR-0024 §2)
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from '../base.endpoints';
import type { ID } from '../../types';

const BASE_PATH = '/FsaCorporateFacts';

export const fsaCorporateFactsEndpoints = {
  /** GET / PUT /api/v1/FsaCorporateFacts/by-engagement/{engId} */
  byEngagement: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId`, { engId }),

  /** PUT /api/v1/FsaCorporateFacts/by-engagement/{engId}/sections (save only the changed sections) */
  sections: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/sections`, { engId }),

  /** GET /api/v1/FsaCorporateFacts/agm-pack/library */
  agmLibrary: () => buildEndpoint(`${BASE_PATH}/agm-pack/library`),

  /** GET /api/v1/FsaCorporateFacts/by-engagement/{engId}/agm-pack/pdf?document=notice|proxy|attendance|all */
  agmPackPdf: (engId: ID, document: string) =>
    `${buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/agm-pack/pdf`, { engId })}?document=${encodeURIComponent(document)}`,

  /** GET /api/v1/FsaCorporateFacts/by-engagement/{engId}/agm-pack/docx?document=… (ADR-0024 R-4, editable Word) */
  agmPackDocx: (engId: ID, document: string) =>
    `${buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/agm-pack/docx`, { engId })}?document=${encodeURIComponent(document)}`,

  /** PUT /api/v1/FsaCorporateFacts/by-engagement/{engId}/audit-answers (ADR-0024 A-1; merged server-side) */
  auditAnswers: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/audit-answers`, { engId }),

  /** POST /api/v1/FsaCorporateFacts/by-engagement/{engId}/import-from-prior (ADR-0024 R-4b; fills an empty record) */
  importFromPrior: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/import-from-prior`, { engId }),

  /** POST /api/v1/FsaCorporateFacts/by-engagement/{engId}/ratio-openings/refresh (ADR-0024 N-5; previous year's openings from its saved Balance Sheet) */
  ratioOpeningsRefresh: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/ratio-openings/refresh`, { engId }),

  /** GET /api/v1/FsaCorporateFacts/by-engagement/{engId}/master-directors (the master's directors for the year; read-only) */
  masterDirectors: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/master-directors`, { engId }),

  /** GET /api/v1/FsaCorporateFacts/by-engagement/{engId}/related-party-import (read-only proposal) */
  relatedPartyImport: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/related-party-import`, { engId }),
} as const;

export default fsaCorporateFactsEndpoints;
